import {BaseFilterModel} from "./baseFilter.model";

export class RiskFactorInfoFilter  extends BaseFilterModel {
  type = null;
  level = null;
  npa = null;
  cause = null;
  scoreDegree = null;
}
